export const FontSansSerif = ["Inter", "sans-serif"].join(",");
